import { blockResolver } from '@/core/component-resolver.service';
import { defineAsyncComponent } from 'vue';

// B2C Public blocks
import B2CLoginTile from '@/b2c/content/blocks/B2CLoginTile.vue';
import B2CResetPasswordTile from '@/b2c/content/blocks/B2CResetPasswordTile.vue';
import B2CCreateProfileTile from '@/b2c/content/blocks/B2CCreateProfileTile.vue';
import B2CCreateProfileConfirmationHeroTile from '@/b2c/content/blocks/hero/B2CCreateProfileConfirmationHeroTile.vue';
import B2CGoodThingsToComeTile from '@/b2c/content/blocks/B2CGoodThingsToComeTile.vue';
import B2CCompactNewsletterTile from '@/b2c/content/blocks/B2CCompactNewsletterTile.vue';
import B2CProductDetailTile from '@/b2c/content/blocks/B2CProductDetailTile.vue';
import B2COutletProductDetailTile from '@/b2c/content/blocks/B2COutletProductDetailTile.vue';
import GiftCardPaymentTile from '@/b2c/content/blocks/payment-options/GiftCardPaymentTileModel.vue';

// B2C Public async blocks
const asyncB2CSpecialDeliveryRequestTile = defineAsyncComponent(() => import(/* webpackPrefetch: true */ './B2CSpecialDeliveryRequestTile.vue'));

// B2CProfile async chunk
const asyncB2CProfileTile = defineAsyncComponent(() => import(/* webpackChunkName: 'B2CProfile', webpackPrefetch: true */ './B2CProfileTile.vue'));
const asyncB2CConfirmEmailTokenHeroTile = defineAsyncComponent(() => import(/* webpackChunkName: 'B2CProfile', webpackPrefetch: true */ './hero/B2CConfirmEmailTokenHeroTile.vue'));
const asyncB2CFavoriteStoreTile = defineAsyncComponent(() => import(/* webpackChunkName: 'B2CProfile', webpackPrefetch: true */ './B2CFavoriteStoreTile.vue'));

// B2CWishList async chunk
const asyncB2CWishListTile = defineAsyncComponent(() => import(/* webpackChunkName: 'B2CWishList', webpackPrefetch: true */ './B2CWishListTile.vue'));
const asyncB2CWishListDetailTile = defineAsyncComponent(() => import(/* webpackChunkName: 'B2CWishList', webpackPrefetch: true */ './B2CWishListDetailTile.vue'));
const asyncB2CWishListPublicSharedTile = defineAsyncComponent(() => import(/* webpackChunkName: 'B2CWishList', webpackPrefetch: true */ './B2CWishListPublicSharedTile.vue'));

// B2COffers async chunk
const asyncB2CMyPersonalOfferConsentTile = defineAsyncComponent(() => import(/* webpackChunkName: 'B2COffers', webpackPrefetch: true */ './B2CMyPersonalOfferConsentTile.vue'));
const asyncB2CMyPersonalOfferDetailTile = defineAsyncComponent(() => import(/* webpackChunkName: 'B2COffers', webpackPrefetch: true */ './B2CMyPersonalOfferDetailTile.vue'));
const asyncB2CMyPersonalOfferOverviewTile = defineAsyncComponent(() => import(/* webpackChunkName: 'B2COffers', webpackPrefetch: true */ './B2CMyPersonalOfferOverviewTile.vue'));
const asyncB2CFindPersonalOfferTile = defineAsyncComponent(() => import(/* webpackChunkName: 'B2COffers', webpackPrefetch: true */ './B2CFindPersonalOfferTile.vue'));

// B2COrders async chunk
const asyncB2CMyOrderDetailTile = defineAsyncComponent(() => import(/* webpackChunkName: 'B2COrders', webpackPrefetch: true */ './B2CMyOrderDetailTile.vue'));
const asyncB2CMyOrdersOverviewTile = defineAsyncComponent(() => import(/* webpackChunkName: 'B2COrders', webpackPrefetch: true */ './B2CMyOrdersOverviewTile.vue'));
const asyncB2CMyOrderChangeDeliveryDateTile = defineAsyncComponent(() => import(/* webpackChunkName: 'B2COrders', webpackPrefetch: true */ './B2CMyOrderChangeDeliveryDateTile.vue'));

// B2CMyBenefits async chunk
const asyncB2CMyBenefitsTile = defineAsyncComponent(() => import(/* webpackChunkName: 'B2CMyBenefits', webpackPrefetch: true */ './B2CMyBenefitsTile.vue'));

// B2CCheckout async chunk
const asyncB2CBasketTile = defineAsyncComponent(() => import(/* webpackChunkName: 'B2CBasket', webpackPrefetch: true */ './B2CBasketTile.vue'));
const asyncB2CCheckoutTile = defineAsyncComponent(() => import(/* webpackChunkName: 'B2CCheckout', webpackPrefetch: true */ './B2CCheckoutTile.vue'));
const asyncB2CReceiptTile = defineAsyncComponent(() => import(/* webpackChunkName: 'B2CReceipt', webpackPrefetch: true */ './B2CReceiptTile.vue'));
const asyncB2CReceiptHeroTile = defineAsyncComponent(() => import(/* webpackChunkName: 'B2CReceipt', webpackPrefetch: true */ './hero/B2CReceiptHeroTile.vue'));

blockResolver.register('B2CProductDetailTileModel', B2CProductDetailTile);
blockResolver.register('B2COutletProductDetailTileModel', B2COutletProductDetailTile);

blockResolver.register('B2CLoginTileModel', B2CLoginTile);
blockResolver.register('B2CResetPasswordTileModel', B2CResetPasswordTile);
blockResolver.register('B2CCreateProfileTileModel', B2CCreateProfileTile);
blockResolver.register('B2CCreateProfileConfirmationHeroTileModel', B2CCreateProfileConfirmationHeroTile);
blockResolver.register('B2CGoodThingsToComeTileModel', B2CGoodThingsToComeTile);
blockResolver.register('B2CCompactNewsletterTileModel', B2CCompactNewsletterTile);

blockResolver.register('B2CSpecialDeliveryRequestTileModel', asyncB2CSpecialDeliveryRequestTile);

blockResolver.register('B2CProfileTileModel', asyncB2CProfileTile);
blockResolver.register('B2CConfirmEmailTokenHeroTileModel', asyncB2CConfirmEmailTokenHeroTile);
blockResolver.register('B2CFavoriteStoreTileModel', asyncB2CFavoriteStoreTile);

blockResolver.register('B2CWishListTileModel', asyncB2CWishListTile);
blockResolver.register('B2CWishListDetailTileModel', asyncB2CWishListDetailTile);
blockResolver.register('B2CWishListPublicSharedTileModel', asyncB2CWishListPublicSharedTile);

blockResolver.register('B2CMyPersonalOfferConsentTileModel', asyncB2CMyPersonalOfferConsentTile);
blockResolver.register('B2CMyPersonalOfferDetailTileModel', asyncB2CMyPersonalOfferDetailTile);
blockResolver.register('B2CMyPersonalOfferOverviewTileModel', asyncB2CMyPersonalOfferOverviewTile);
blockResolver.register('B2CFindPersonalOfferTileModel', asyncB2CFindPersonalOfferTile);

blockResolver.register('B2CMyOrderDetailTileModel', asyncB2CMyOrderDetailTile);
blockResolver.register('B2CMyOrdersOverviewTileModel', asyncB2CMyOrdersOverviewTile);
blockResolver.register('B2CMyOrderChangeDeliveryDateTileModel', asyncB2CMyOrderChangeDeliveryDateTile);

blockResolver.register('MyBenefitsTileModel', asyncB2CMyBenefitsTile);

blockResolver.register('B2CBasketTileModel', asyncB2CBasketTile);
blockResolver.register('B2CCheckoutTileModel', asyncB2CCheckoutTile);
blockResolver.register('B2CReceiptTileModel', asyncB2CReceiptTile);
blockResolver.register('B2CReceiptHeroTileModel', asyncB2CReceiptHeroTile);

blockResolver.register('GiftCardPaymentTileModel', GiftCardPaymentTile);
